<template>
  <div v-if="item" class="p-bot-6">
    <WidgetSliderSwiper
      :length="props.item.length"
      :title="item.sectionTitle"
      :text="item.text"
      class="image-text-link-swiper"
    >
      <template
        v-for="(slide, index) in props.item"
        :key="index"
        #[`slide-${index}`]
      >
        <PagesNewsImageTextLinkSwiperSlide :item="slide" :type="type" />
      </template>
    </WidgetSliderSwiper>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'PagesNewsImageTextLinkSwiper',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
